import { render, staticRenderFns } from "./popup_report_error.vue?vue&type=template&id=70f15cdc&scoped=true&lang=pug"
import script from "./popup_report_error.vue?vue&type=script&lang=js"
export * from "./popup_report_error.vue?vue&type=script&lang=js"
import style0 from "../../assets/koromo_min.css?vue&type=style&index=0&id=70f15cdc&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f15cdc",
  null
  
)

export default component.exports